module.exports = require("lru-cache");


//////////////////
// WEBPACK FOOTER
// external "lru-cache"
// module id = 42
// module chunks = 0